import React, { useEffect, useState } from "react";
import "./Subscri_History.css";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { Pagination } from "react-bootstrap";
import NotFound from "common/NotFound";
import { pdf_icon, userPlaceholder } from "assets/icons";
import { CgBlock, CgUnblock } from "react-icons/cg";
import useFullPageLoader from "common/UseFullPageLoader";
import { subscriptionTransactionListApi } from "services/subscription";
import { dateFormat } from "utils/dateFormat";
import { capitalize } from "@mui/material";

const Subscri_History = ({userId}) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [subscription, setSubscription] = useState([]);

  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await subscriptionTransactionListApi({ _id: userId });
      if (status === 200) {
        setSubscription(data?.data);

      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  console.log({subscription});
  
  // const [subscriptionHistoryList, setSubscriptionList] = useState([
  //   {
  //     transactionId: "TXN12345",
  //     transactionDate: "2024-02-10",
  //     transactionType: "Credit",
  //     amount: 100.0,
  //     invoice: "INV-001"
  //   },
  //   {
  //     transactionId: "TXN12346",
  //     transactionDate: "2024-02-12",
  //     transactionType: "Debit",
  //     amount: 50.0,
  //     invoice: "INV-002"
  //   }
  // ]);

  return (
    <>
      <div className="subcri_history_parent">
        <div className="student_management">
          <div className="dashboard_title">
            <h3>Subscription History</h3>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="table_wrap ">
                <table className="table custom_table">
                  <thead>
                    <tr>
                      <th className="nowrap text-center">S.No</th>
                      <th className="nowrap text-center">Transation Date</th>
                      <th className="nowrap text-center">Transaction Status</th>
                      <th className="nowrap text-center">Amount</th>
                      {/* <th className="nowrap text-center">Invoice </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {loader}
                    {subscription &&
                      subscription.length ? (
                      subscription?.map((data, index) => {
                        return (
                          <tr key={index}>
                            <td className="nowrap text-center">
                              {/* {findSerialNumber(index, activePage, limits)} */}
                              {++index}
                            </td>
                            <td className="nowrap text-center">
                              {dateFormat(data?.createdAt)}
                            </td>
                            <td className="nowrap text-center">
                              {(capitalize(data?.status?.toLowerCase()) || "")}
                            </td>
                            <td className="nowrap text-center">
                              $ {data?.price}
                            </td>
                            {/* <td
                              className="nowrap text-center pdf_icons"
                              style={{ textTransform: "capitalize" }}
                            >
                              <img src={pdf_icon} />
                            </td> */}
                          </tr>
                        );
                      })
                    ) : (
                      <NotFound
                        cols={10}
                        msg={"Subcription History Data not found"}
                        onHide={onHide}
                      />
                    )}
                  </tbody>
                </table>
              </div>

              {/* <div className="pagination-wrapper">
              <div className="Pagination">
                <select
                  className="input form-control"
                  value={limits}
                  onChange={handleLimit}
                >
                  {limitOption &&
                    limitOption.length > 0 &&
                    limitOption.map((limitValue) => (
                      <option key={limitValue.value} value={limitValue.value}>
                        {limitValue.label}
                      </option>
                    ))}
                </select>
              </div>
            </div> */}
              {/* {total > limits && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limits}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Subscri_History;
